import { OpenAreaCampaign, PaymentSignature } from "@edp-models/open-area.model";

export interface IOpenAreaState {
    campaign: OpenAreaCampaign;
    signature: any;
    code: any;
    banks: [];
    paymentStatus: any;
    payment: any;
    newCode: any;
}

export const initialOpenAreaState: IOpenAreaState = {
    campaign: null,
    signature: null,
    code: null,
    banks: [],
    paymentStatus: null,
    payment: null,
    newCode: null
};
